import { EVENT_MOUNTED, Splide } from "@splidejs/splide";

export function SetBackgroundColorAfterBefore(Splide, Components, options) {
    function mount() {
        const splideElement = Splide.root;
        const parentSection = splideElement.closest('section');

        if (parentSection) {
            const parentBgColor = window.domUtils.getBackgroundColor(splideElement) ?? 'transparent';
            const splideId = splideElement.id;
            const style = document.createElement('style');
            const paginationElement = splideElement.querySelector('.splide__pagination');
            let bottom = 44;
            if (paginationElement) {
                const paginationHeight = paginationElement.offsetHeight;
                bottom = paginationHeight + 10;
            }

            style.innerHTML = `
                #${splideId}::after, #${splideId}::before {
                    background-color: ${parentBgColor};
                    box-shadow: 0 0 12px 10px ${parentBgColor};
                }

                #${splideId}::after {
                    bottom: ${bottom}px !important;
                }
            `;
            document.head.appendChild(style);
        }
    }

    function destroy() {}

    return {
        mount,
        destroy,
    };
}
